export default __webpack_public_path__ + "static/media/caashcredenciado.5b0eebaa.jpg";